import React from 'react'
import v8 from './../../../images/v8.jpg'
import barline from './../../../images/Bar_line.png'

import min1 from '../../../images/min1.JPG'
import min2 from '../../../images/min2.JPG'


import min7 from '../../../images/min7.JPG'
import min8 from '../../../images/min8.JPG'
import min9 from '../../../images/min9.JPG'


import min3 from '../../../images/min3.jpg'
import min4 from '../../../images/min4.jpg'
import min5 from '../../../images/min5.jpg'

import hajA from '../../../images/hajA.jpg'
import hajB from '../../../images/hajB.jpg'
import hajC from '../../../images/hajC.jpg'
import hajD from '../../../images/hajD.jpg'

import haj2 from '../../../images/haj2.JPG'

import haj3 from '../../../images/haj3.jpg'
import haj4 from '../../../images/haj4.jpg'
import haj5 from '../../../images/haj5.jpg'
import haj6 from '../../../images/haj6.jpg'
import haj7 from '../../../images/haj7.JPG'
import haj8 from '../../../images/haj8.JPG'


import man1 from '../../../images/man1.jpg'
import man2 from '../../../images/man2.jpg'
import man3 from '../../../images/man3.jpg'
import man4 from '../../../images/man4.jpg'
import man5 from '../../../images/man5.JPG'
import man6 from '../../../images/man6.JPG'
import man7 from '../../../images/man7.JPG'
import man8 from '../../../images/man8.JPG'

import kd1 from '../../../images/kd1.JPG'
import kd2 from '../../../images/kd2.JPG'
import kd3 from '../../../images/kd3.JPG'

import b1 from '../../../images/b1.JPG'
import b2 from '../../../images/b2.JPG'
import b3 from '../../../images/b3.JPG'
import b4 from '../../../images/b3.JPG'


import mb4 from '../../../images/mb4.jpg'
import mb12 from '../../../images/mb12.jpg'

import mb1 from '../../../images/mb1.JPG'
import mb2 from '../../../images/mb2.jpg'
import mb3 from '../../../images/mb3.jpg'
import mb5 from '../../../images/mb5.jpg'

import mb6 from '../../../images/mb6.jpg'
import mb7 from '../../../images/mb7.jpg'
import mb8 from '../../../images/mb8.JPG'
import mb9 from '../../../images/mb9.JPG'
import mb10 from '../../../images/mb10.JPG'
import mb11 from '../../../images/mb11.JPG'





const First_Pane = () => (
    <div>
    <div
       style={{ backgroundImage: `url(${v8})`,
       backgroundRepeat: 'no-repeat',
       backgroundSize: 'cover',
       paddingBottom: '50px',
       paddingTop: '100px',
       height: '100vh'
   }}

   >

       <div className='uk-container'>
      <div className='uk-grid' data-uk-grid>
                      
           <div className='uk-width-1-2@s uk-margin-medium-bottom'>
               <h1 className='light uk-text-bold uk-padding-small uk-margin-xlarge-top'>Portfolio</h1>
               <p className=' light uk-padding-small'></p>
            </div>
             <div className='uk-width-1-2@s'>

            </div>
            </div> 



        
      <div className='blueBg '>
        <div className=''>       
             <div className=''>

          <div class="uk-text-center" data-uk-grid>
                <div class="uk-width-1-6@s">
                </div>
                <div class="uk-width-4-6@s">
                    
                <div className='uk-text-center'>
                        <h3 className='light header3 uk-padding uk-text-bold'>
                            We pride ourselves on our expertise as well as our company culture. 
                        No matter what place or field we work, 
                        every Toolbox Atelien shares a passion for excellence.   </h3>
                    </div>
                </div>
                </div>

                <div class="uk-width-1-6@s">
                </div>
           </div>


          </div>

      </div>

        


      </div>

   </div>



                            
                            
                            {/******* FIRST PORTFOLIO ******/}
                       
                               <div class="uk-container uk-margin-xlarge-top">  
                                           <h3 className='uk-margin-xlarge-top uk-text-center uk-text-bold'>Toolbox at its best</h3>
                                       <ul class="uk-tab" id="js-control" data-uk-tab="{connect:'#my-id4'}">
                                           <li id="tab1"><a href="">Toolbox Residence Minna</a></li>
                                           <li id="tab2"><a href="">Hajman Interior Remodelling</a></li>
                                           <li id="tab3"><a href="">Hajman Serviced Apartment</a></li>
                                           <li id="tab3"><a href="">Kaduna Boite Residence</a></li>
                                           <li id="tab3"><a href="">Bauchi Boite Residence</a></li>
                                            <li id="tab3"><a href=""> Minna Boite Residence </a></li>
                                           
                                       </ul>
                                       <ul id="my-id4" class="uk-switcher uk-margin">
                       
                                           {/*First Tab*/}
                                           <li> 
                                                <div className='uk-text-center'>
                                                <h1 className='uk-text-bold'>Toolbox Residence Minna</h1>
                                                <h4>Residential Remodeling / Construction</h4>
                                                <p>Off Okay Road, Behind Scorpion House, Minna Niger State 2022</p>
                                                </div>

                                        


                                             <div className='uk-grid'>
                                                <div className='uk-width-1-3@s'>
                                                      <img src={min7} />
                                                </div>

                                                 <div className='uk-width-1-3@s'>
                                                      <img src={min8} />
                                                </div>


                                                 <div className='uk-width-1-3@s'>
                                                      <img src={min9} />
                                                </div>
                                            </div>




                                                <div className='uk-grid'>
                                                <div className='uk-width-1-2@s'>
                                                      <img src={min1} />
                                                </div>

                                                 <div className='uk-width-1-2@s'>
                                                      <img src={min2} />
                                                </div>   
                                            </div>


                                              <div className='uk-grid'>
                                                <div className='uk-width-1-3@s'>
                                                      <img src={min4} />
                                                </div>

                                                 <div className='uk-width-1-3@s'>
                                                      <img src={min4} />
                                                </div>


                                                 <div className='uk-width-1-3@s'>
                                                      <img src={min5} />
                                                </div>
                                            </div>

                                           
                                           </li>
                                           {/*First Tab ends here*/}
                                          
                       
                       
                       
                       
                                          {/*Second Tab STARTS here*/}
                                          <li>
                                                <div className='uk-text-center'>
                                                <h1 className='uk-text-bold'>Hajman Interior Remodelling</h1>
                                                <h4>Furniture showroom (Remodelling)</h4>
                                                <p>Wuse Zone 7, Abuja, Nigeria. 2021</p>
                                                </div>

                                           <div className='uk-grid'>
                                               <div className='uk-width-1-4@s'>
                                                     <img src={hajA} />
                                               </div>

                                                <div className='uk-width-1-4@s'>
                                                     <img src={hajB} />
                                               </div>

                                                <div className='uk-width-1-4@s'>
                                                     <img src={hajC} />
                                               </div>

                                                <div className='uk-width-1-4@s'>
                                                    <img src={hajD} />
                                               </div>
                                           </div>

                                           
                                           <div className='uk-grid'>
                                               <div className='uk-width-1-2@s'>
                                               
                                               </div>

                                                <div className='uk-width-1-2@s'>
                                                <img src={haj2} />
                                               </div>
                                           </div>


                                           <div className='uk-grid'>
                                                <div className='uk-width-1-3@s'>
                                                 <img src={haj3} />
                                                </div>

                                                 <div className='uk-width-1-3@s'>
                                                   <img src={haj4} />
                                                </div>


                                                 <div className='uk-width-1-3@s'>
                                                  <img src={haj5} />
                                                </div>
    
                                           </div>


                                           </li>
                       
                                          {/*Second Tab ENDS  here*/}
                       
                       
                       
                       
                       
                       
                       
                       
                                          {/*Third Tab STARTS here*/}
                                          <li>
                                            <div className='uk-text-center'>
                                                <h1 className='uk-text-bold'>Hajman Serviced Apartment </h1>
                                                <h4>Residential</h4>
                                                <p>Jahi, Abuja, Nigeria 2021</p>
                                            </div>

                                            <div className='uk-grid'>
                                               <div className='uk-width-1-3'>
                                               <img src={man1} />
                                               </div>


                                                <div className='uk-width-1-3'>
                                              <img src={man2} />
                                               </div>



                                                <div className='uk-width-1-3'>
                                               <img src={man3} />
                                               </div>
                                            </div>




                                             <div className='uk-grid'>
                                               <div className='uk-width-1-3'>
                                               <img src={man4} />
                                               </div>


                                                <div className='uk-width-1-3'>
                                              <img src={man5} />
                                               </div>



                                                <div className='uk-width-1-3'>
                                               <img src={man6} />
                                               </div>
                                            </div>


                                             <div className='uk-grid'>
                                               <div className='uk-width-1-2'>
                                               <img src={man7} />
                                               </div>


                                                <div className='uk-width-1-2'>
                                              <img src={man8} />
                                               </div>

                                            </div>

                                         </li>
                                 {/*Third Tab ENDS  here*/}




        

                                      {/*FOURTH Tab STARTS here*/}
                                          <li>
                                            <div className='uk-text-center'>
                                                <h1 className='uk-text-bold'>Kaduna Boite Residence </h1>
                                                <h4>Kaduna, Nigeria</h4>
                                                <p>2021</p>
                                            </div>

                                            <div className='uk-grid'>
                                               <div className='uk-width-1-3'>
                                               <img src={kd1} />
                                               </div>


                                                <div className='uk-width-1-3'>
                                              <img src={kd2} />
                                               </div>



                                                <div className='uk-width-1-3'>
                                               <img src={kd3} />
                                               </div>
                                            </div>

  

                                         </li>
                                 {/*FOURTH Tab ENDS  here*/}




                                    {/*FIFTH Tab STARTS here*/}
                                          <li>
                                            <div className='uk-text-center'>
                                                <h1 className='uk-text-bold'> Bauchi Boite Residence </h1>
                                                <h4>Residential Design / Construction</h4>
                                                <p>2020</p>
                                            </div>

                                            <div className='uk-grid'>
                                               <div className='uk-width-1-2'>
                                               <img src={b1} />
                                               </div>


                                                <div className='uk-width-1-2'>
                                              <img src={b2} />
                                               </div>

                                            </div>


                                            <div className='uk-grid'>
                                               <div className='uk-width-1-2'>
                                               <img src={b3} />
                                               </div>


                                                <div className='uk-width-1-2'>
                                              <img src={b4} />
                                               </div>

                                            </div>

  

                                         </li>
                                 {/*FIFTH Tab ENDS  here*/}






                                 
                                    {/*SIXTH Tab STARTS here*/}
                                          <li>
                                            <div className='uk-text-center'>
                                                <h1 className='uk-text-bold'> Minna Boite Residence </h1>
                                                <h4>Residential Construction</h4>
                                                <p>2020</p>
                                            </div>

                                            <div className='uk-grid'>
                                               <div className='uk-width-1-2'>
                                               <img src={mb12} />
                                               </div>


                                                <div className='uk-width-1-2'>
                                              <img src={mb4} />
                                               </div>

                                            </div>


                                            <div className='uk-grid'>
                                               <div className='uk-width-1-2'>
                                               <img src={mb3} />
                                               </div>


                                                <div className='uk-width-1-2'>
                                              <img src={mb5} />
                                               </div>

                                            </div>



                                              <div className='uk-grid'>
                                               <div className='uk-width-1-4'>
                                               <img src={mb6} />
                                               </div>


                                                <div className='uk-width-1-4'>
                                              <img src={mb7} />
                                               </div>

                                                  <div className='uk-width-1-4'>
                                              <img src={mb8} />
                                               </div>


                                                  <div className='uk-width-1-4'>
                                              <img src={mb9} />
                                               </div>

                                            </div>



                                                 <div className='uk-grid'>
                                               <div className='uk-width-1-2'>
                                               <img src={mb10} />
                                               </div>


                                                <div className='uk-width-1-2'>
                                              <img src={mb11} />
                                               </div>

                                               

                                            </div>

  

                                         </li>
                                 {/*SIXTH Tab ENDS  here*/}







                        














                                          
                                       </ul>
                                       
                                      
                       
                              </div>
                               </div>



















                                    




  )


export default First_Pane